import { render } from "./LanguageSwitcherComponent.vue?vue&type=template&id=ad0dcc2e&scoped=true"
import script from "./LanguageSwitcherComponent.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcherComponent.vue?vue&type=script&lang=js"

import "./LanguageSwitcherComponent.vue?vue&type=style&index=0&id=ad0dcc2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad0dcc2e"]])

export default __exports__